import {
    SET_GAME_ALL,
    SET_GAME_DEMO,
    SET_SCROLL_POSITION,
    SET_SCROLL_MOVE,
    SET_OPEN_GAME,
    SET_LOAD_GAME_ALL,
    SET_GAME_POPPULAR_ALL,
    SET_GAME_LAST_ALL,
    SET_GAME_LIKE_LIST
} from './../../actions/game/index';

const initialState = {
    itemsGameList: false,
    itemGameDemo: null,
    itemsGamePoppularList: null,
    itemsGameLastAll: null,
    itemsGameLikeList: null,
    scrollStatus: false,
    scrollMove: false,
    gamePlay: null,
    loadGameList: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_GAME_ALL:
            return { ...state, itemsGameList: action.payload.items };
        case SET_GAME_POPPULAR_ALL:
            return { ...state, itemsGamePoppularList: action.payload.items };
        case SET_GAME_LAST_ALL:
            return { ...state, itemsGameLastAll: action.payload.items };
        case SET_GAME_LIKE_LIST:
            return { ...state, itemsGameLikeList: action.payload.items };
        case SET_LOAD_GAME_ALL:
            return { ...state, loadGameList: action.payload.items };
        case SET_GAME_DEMO:
            return { ...state, itemGameDemo: action.payload.items };
        case SET_SCROLL_POSITION:
            return { ...state, scrollStatus: action.payload.items };
        case SET_SCROLL_MOVE:
            return { ...state, scrollMove: action.payload.items };
        case SET_OPEN_GAME:
            return { ...state, gamePlay: action.payload.items };
        default:
            return state;
    }
}